function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 39,
  r: 24,
  fill: "#CACAF1"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14 39L23.5455 24L33.0909 39L23.5455 44.4545L14 39Z",
  fill: "#9FA8DA"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M23.5459 24L33.0914 39L23.5459 44.4545V24Z",
  fill: "#7986CB"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M14 41.0455L23.5455 46.5L33.0909 41.0455L23.5455 54L14 41.0455Z",
  fill: "#9FA8DA"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M23.5459 46.5L33.0914 41.0455L23.5459 54V46.5Z",
  fill: "#7986CB"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M14 39L23.5455 34.9091L33.0909 39L23.5455 44.4545L14 39Z",
  fill: "#7986CB"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M23.5459 34.9091L33.0914 39L23.5459 44.4545V34.9091Z",
  fill: "#5C6BC0"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M110 58C123.255 58 134 47.2548 134 34C134 20.7452 123.255 10 110 10C96.7452 10 86 20.7452 86 34C86 47.2548 96.7452 58 110 58Z",
  fill: "#6E97FF"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M114.253 41.6318V37.4958H115.388V40.3118H116.77V38.0238H117.852V40.3118H119.278V37.399H120.413V41.6318H114.253Z",
  fill: "#1E1A31"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M114.253 37.0419V32.1667H115.388V33.9443H120.413V35.2643H115.388V37.0419H114.253Z",
  fill: "#1E1A31"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M114.253 31.4482V30.1282H116.726V27.6818H114.253V26.3618H120.413V27.6818H117.87V30.1282H120.413V31.4482H114.253Z",
  fill: "#1E1A31"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M99.9422 42.5842L98.1113 41.2779L109.627 25.2775L111.458 26.5837L99.9422 42.5842Z",
  fill: "#1E1A31"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M105.874 32.8779H106.489C109.319 32.8779 111.614 35.1647 111.614 37.9856C111.614 40.8065 109.319 43.0933 106.489 43.0933H98.9529C98.3312 43.0933 97.8271 42.591 97.8271 41.9713C97.8271 41.3515 98.3312 40.8492 98.9529 40.8492H106.489C108.076 40.8492 109.362 39.5671 109.362 37.9856C109.362 36.4041 108.076 35.1221 106.489 35.1221H103.567H103.566H102.952C100.122 35.1221 97.8271 32.8353 97.8271 30.0144C97.8271 27.1935 100.122 24.9067 102.952 24.9067H110.488C111.11 24.9067 111.614 25.409 111.614 26.0287C111.614 26.6484 111.11 27.1508 110.488 27.1508H102.952C101.365 27.1508 100.079 28.4329 100.079 30.0144C100.079 31.5959 101.365 32.8779 102.952 32.8779H105.874C105.874 32.8779 105.874 32.8779 105.874 32.8779Z",
  fill: "#1E1A31"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M75.6352 7.94785L75.8098 7.47932L75.8098 7.47932L75.6352 7.94785ZM80.5112 10.1419C80.7623 10.0271 80.8729 9.73044 80.7581 9.47929L78.8873 5.38659C78.7725 5.13544 78.4758 5.02491 78.2247 5.13971C77.9735 5.25451 77.863 5.55117 77.9778 5.80232L79.6407 9.44028L76.0028 11.1032C75.7516 11.218 75.6411 11.5146 75.7559 11.7658C75.8707 12.0169 76.1673 12.1275 76.4185 12.0127L80.5112 10.1419ZM75.4606 8.41639L80.1287 10.1557L80.4779 9.21862L75.8098 7.47932L75.4606 8.41639ZM47.7129 12.6793C55.5965 6.54138 66.0981 4.928 75.4606 8.41639L75.8098 7.47932C66.1221 3.8698 55.2559 5.53921 47.0986 11.8903L47.7129 12.6793Z",
  fill: "#484697"
});

var SvgBuySEth = function SvgBuySEth(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 63,
    viewBox: "0 0 134 63",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBuySEth, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/buy-sETH.7539cb79.svg";
export { ForwardRef as ReactComponent };